
namespace RioERP.Orders {
    export class InstamojoSettingsColumns {
        static columnsKey = 'Orders.InstamojoSettings';
    }
}